import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoanerWheelInventoryState } from '../../../store/state/loaner-wheel-inventory.state';
import { Store, select } from '@ngrx/store';
import { SelectTireSizes, SelectModelTypes } from '../../../store/app.selector';
import { TireSize, Inventory } from '../../../models/loaner-wheel-inventory';
import { I18nService } from "../../../../shared/services/i18n.service";
@Component({
  selector: 'app-inventory-form',
  templateUrl: './inventory-form.component.html',
  styleUrls: ['./inventory-form.component.scss']
})
export class InventoryFormComponent implements OnInit {
  inventoryForm: FormGroup;
  locations: any[];
  models: any[];
  tiresizes: any[];
  filteredSizes: any[];
  supplierCode: string;
  data: Inventory = null;
  get inventoryFormControls() {
    return {
      location: this.inventoryForm.get('location'),
      model: this.inventoryForm.get('model'),
      tiresize: this.inventoryForm.get('tiresize'),
      quantity: this.inventoryForm.get('quantity')
    };
  }

  constructor(private fb: FormBuilder,
    public dialogRef: MatDialogRef<InventoryFormComponent>,
    private translateService: I18nService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private store: Store<LoanerWheelInventoryState>) {
    this.inventoryForm = this.fb.group({
      location: [null, Validators.required],
      model: [{ value: null, disabled: true }, Validators.required],
      tiresize: [{ value: null, disabled: true }, Validators.required],
      quantity: [null, [Validators.required,  Validators.pattern("^[0-9]*$")]]
    });
    this.data = dialogData.item;
    this.supplierCode = dialogData.supplierCode;
  }

  ngOnInit() {
    this.loadResources();
    if (this.data) {
      this.filteredSizes = this.tiresizes;
      this.inventoryForm = this.fb.group({
        location: [{
          value: this.dialogData.locations ? this.dialogData.locations.find(x => x.locationId == this.data.locationId) : this.dialogData.locations,
          disabled: true
        }],
        model: [{
          value: this.models ? this.models.find(m => m.id == this.data.modelTypeId) : null,
          disabled: true
        }],
        tiresize: [{
          value: this.filteredSizes ? this.filteredSizes.find(m => m.id == this.data.tireSizeId) : null,
          disabled: true
        }],
        quantity: [{ value: this.data.quantity, disabled: null }, [Validators.required,  Validators.pattern("^[0-9]*$")]]
      });
    }
  }

  loadResources() {
    this.store.pipe(select(SelectModelTypes)).subscribe(types => {
      if (types && types.length > 0) {
        this.models = types;
      }
    });
    this.store.pipe(select(SelectTireSizes)).subscribe(sizes => {
      if (sizes && sizes.length > 0) {
        this.tiresizes = sizes;
      }
    });
  }

  onLocationChange(event: any) {
    this.inventoryForm.controls['model'].enable();
  }

  onModelChange(event: any) {
    this.inventoryForm.controls['tiresize'].enable();
    this.filteredSizes = this.filterType(event.value);
  }

  private filterType(value: any): TireSize[] {
    const filterValue = value.id;
    if (this.tiresizes) {
      return this.tiresizes.filter(
        size => size.modelTypeId == filterValue);
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }

  save() {
    if (this.inventoryForm.invalid) {
      return;
    }
    if (this.data == null) {
      this.data = new Inventory();
    }
    this.data.locationId = this.inventoryFormControls.location.value.locationId;
    this.data.modelTypeId = this.inventoryFormControls.model.value.id;
    this.data.tireSizeId = this.inventoryFormControls.tiresize.value.id;
    this.data.quantity = this.inventoryFormControls.quantity.value;
    this.dialogRef.close(this.data);
  }
}
